/*
 * @Author: Chao Yang
 * @Date: 2020-08-05 02:00:49
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-08-13 00:38:43
 */
import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { setMonth } from 'date-fns';

@Component({
  selector: 'ad-month-picker',
  templateUrl: './month-picker.component.html',
  styleUrls: ['./month-picker.component.css'],
})
export class MonthPickerComponent implements OnInit {
  @Input("max") max?: Date;
  @Input("min") min?: Date;
  @Input() currentDate?: Date;
  @Output() onSelect: EventEmitter<number> = new EventEmitter<number>();
  monthList: any[] = [
    { text: 'Jan', value: 1 },
    { text: 'Feb', value: 2 },
    { text: 'Mar', value: 3 },
    { text: 'Apr', value: 4 },
    { text: 'May', value: 5 },
    { text: 'Jun', value: 6 },
    { text: 'Jul', value: 7 },
    { text: 'Aug', value: 8 },
    { text: 'Sep', value: 9 },
    { text: 'Oct', value: 10 },
    { text: 'Nov', value: 11 },
    { text: 'Dec', value: 12 },
  ];
  constructor() { }

  ngOnInit() {
    if ((this.max || this.min) && this.currentDate) {
      let list = [];
      this.monthList.forEach(item => {
        item["date"] = setMonth(this.currentDate, item.value - 1);
      })
    }
  }

  monthClick(month: number) {
    this.onSelect.emit(month);
  }
}
